module.exports = __webpack_public_path__ + "img/791-04ab07.png";